import { z } from 'zod';

import { WorkflowDefinitionId } from '../../../BrandedIds';
import { BankruptcyChapter } from '../../../loan/Bankruptcy';

export type ApplyRepaymentPlanAction = z.infer<typeof ApplyRepaymentPlanAction>;
export const ApplyRepaymentPlanAction = z.object({
  type: z.literal('applyRepaymentPlan'),
});

export type ApplyForbearancePlanAction = z.infer<typeof ApplyForbearancePlanAction>;
export const ApplyForbearancePlanAction = z.object({
  type: z.literal('applyForbearancePlan'),
});

export type ApplyPaymentDeferralAction = z.infer<typeof ApplyPaymentDeferralAction>;
export const ApplyPaymentDeferralAction = z.object({
  type: z.literal('applyPaymentDeferral'),
});

export type ManageLoanStopsAction = z.infer<typeof ManageLoanStopsAction>;
export const ManageLoanStopsAction = z.object({
  type: z.literal('manageLoanStops'),
});

export type PhoneCallAction = z.infer<typeof PhoneCallAction>;
export const PhoneCallAction = z.object({
  type: z.literal('phoneCall'),
});

export type StartWorkflowAction = z.infer<typeof StartWorkflowAction>;
export const StartWorkflowAction = z.object({
  type: z.literal('startWorkflow'),
  workflowDefinitionId: WorkflowDefinitionId,
});

export type OrderInspectionAction = z.infer<typeof OrderInspectionAction>;
export const OrderInspectionAction = z.object({
  type: z.literal('orderInspection'),
});

export type RecordObtainedInspectionAction = z.infer<typeof RecordObtainedInspectionAction>;
export const RecordObtainedInspectionAction = z.object({
  type: z.literal('recordObtainedInspection'),
});

export type RecordAppraisalAction = z.infer<typeof RecordAppraisalAction>;
export const RecordAppraisalAction = z.object({
  type: z.literal('recordAppraisal'),
  preallocatedRefKey: z.string(),
});

export type ApplyREOStatusAction = z.infer<typeof ApplyREOStatusAction>;
export const ApplyREOStatusAction = z.object({
  type: z.literal('applyREOStatus'),
});

export type InitiateBankruptcyAction = z.infer<typeof InitiateBankruptcyAction>;
export const InitiateBankruptcyAction = z.object({
  type: z.literal('initiateBankruptcy'),
  /** Pre-selects a bankruptcy chapter in the "Record Bankruptcy" form the action opens. */
  defaultChapter: BankruptcyChapter.optional(),
});

export type ApplyForeclosureFlagAction = z.infer<typeof ApplyForeclosureFlagAction>;
export const ApplyForeclosureFlagAction = z.object({
  type: z.literal('applyForeclosureFlag'),
});

export type RecordOrderedAppraisalAction = z.infer<typeof RecordOrderedAppraisalAction>;
export const RecordOrderedAppraisalAction = z.object({
  type: z.literal('recordOrderedAppraisal'),
});

export type GenerateBankruptcyProofOfClaimFormAction = z.infer<typeof GenerateBankruptcyProofOfClaimFormAction>;
export const GenerateBankruptcyProofOfClaimFormAction = z.object({
  type: z.literal('generateBankruptcyProofOfClaimForm'),
});

export type AddBankruptcyFeeAction = z.infer<typeof AddBankruptcyFeeAction>;
export const AddBankruptcyFeeAction = z.object({
  type: z.literal('addBankruptcyFee'),
});

export type ViewEvaluationNoticeTemplateAction = z.infer<typeof ViewEvaluationNoticeTemplateAction>;
export const ViewEvaluationNoticeTemplateAction = z.object({
  type: z.literal('viewEvaluationNoticeTemplate'),
});

export type CloseRepaymentPlanAction = z.infer<typeof CloseRepaymentPlanAction>;
export const CloseRepaymentPlanAction = z.object({
  type: z.literal('closeRepaymentPlan'),
});

export type Action = z.infer<typeof Action>;
export const Action = z.discriminatedUnion('type', [
  ApplyRepaymentPlanAction,
  ApplyForbearancePlanAction,
  ApplyPaymentDeferralAction,
  ManageLoanStopsAction,
  PhoneCallAction,
  StartWorkflowAction,
  OrderInspectionAction,
  RecordObtainedInspectionAction,
  RecordAppraisalAction,
  ApplyREOStatusAction,
  InitiateBankruptcyAction,
  ApplyForeclosureFlagAction,
  RecordOrderedAppraisalAction,
  GenerateBankruptcyProofOfClaimFormAction,
  AddBankruptcyFeeAction,
  ViewEvaluationNoticeTemplateAction,
  CloseRepaymentPlanAction,
]);
